import { create } from 'zustand'

export type ToastTone = 'info' | 'warning' | 'error'

export interface Toast {
  id: string
  message: string
  tone: ToastTone
}

interface ToastState {
  toasts: Toast[]
  showToast: (message: string, tone?: ToastTone) => void
  dismissToast: (toastId: string) => void
}

const TOAST_DURATION_MS = 3_000
const MAX_VISIBLE_TOASTS = 3

let toastSequence = 0

export const useToastStore = create<ToastState>()((setState, getState) => ({
  toasts: [],

  showToast: (message, tone = 'info') => {
    // The same message firing from parallel failing requests should appear only once.
    const isAlreadyVisible = getState().toasts.some((toast) => toast.message === message)
    if (isAlreadyVisible) {
      return
    }
    toastSequence += 1
    const toastId = `toast-${toastSequence}`
    setState((state) => ({
      toasts: [...state.toasts, { id: toastId, message, tone }].slice(-MAX_VISIBLE_TOASTS),
    }))
    window.setTimeout(() => getState().dismissToast(toastId), TOAST_DURATION_MS)
  },

  dismissToast: (toastId) => {
    setState((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== toastId) }))
  },
}))

/** For non-React code (query callbacks, services). Components should use `useToastStore`. */
export function showToast(message: string, tone?: ToastTone): void {
  useToastStore.getState().showToast(message, tone)
}
